module.exports = __webpack_public_path__ + "img/atendimento_saude.e98b49fc.svg";